import { useState } from "react";
import { CreditCard, Landmark } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";
import { Card, Pill, inputCls, btnPrimary, btnOutline, errMsg, money, fmtDate } from "./ui";

function PayInvoice({ inv, onUpdated }) {
  const [ref, setRef] = useState("");
  const [note, setNote] = useState("");
  const report = async () => {
    try {
      onUpdated((await api.post(`/org/invoices/${inv.id}/transfer`, { reference: ref, note })).data);
      toast.success("Transfer reported — DentiCision will confirm and activate your contract");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Card data-testid="org-pay-card">
      <p className="font-heading font-semibold text-[#0B2545]">Pay invoice {inv.number} · {money(inv.amount, inv.currency)}</p>
      <div className="grid md:grid-cols-2 gap-4 mt-4">
        <div className="rounded-xl border-2 border-[#1C6FE3]/40 p-5">
          <p className="font-semibold flex items-center gap-2"><CreditCard className="w-4 h-4 text-[#1C6FE3]" /> Pay online with Tap</p>
          <p className="text-xs text-slate-500 mt-1">Card / mada / Apple Pay on Tap's secure page. DentiCision never stores card details.</p>
          <button type="button" disabled className={`${btnPrimary} w-full mt-4`} data-testid="org-pay-tap">Pay online</button>
          <p className="text-[11px] text-amber-700 mt-2">Online payment is coming soon — please use bank transfer for now.</p>
        </div>
        <div className="rounded-xl border border-slate-200 p-5">
          <p className="font-semibold flex items-center gap-2"><Landmark className="w-4 h-4" /> Bank transfer</p>
          <p className="text-xs text-slate-500 mt-1">Request bank details in Messages, transfer using invoice number <b>{inv.number}</b>, then report it here and attach the receipt in Messages.</p>
          <input className={`${inputCls} mt-3`} placeholder="Transfer reference" value={ref} onChange={(e) => setRef(e.target.value)} data-testid="org-transfer-ref" />
          <input className={`${inputCls} mt-2`} placeholder="Note (optional)" value={note} onChange={(e) => setNote(e.target.value)} data-testid="org-transfer-note" />
          <button type="button" className={`${btnOutline} w-full mt-3`} onClick={report} data-testid="org-transfer-submit">{inv.status === "pending_confirmation" ? "Update transfer details" : "I have transferred the payment"}</button>
        </div>
      </div>
    </Card>
  );
}

export function OrgBilling({ org, onUpdated }) {
  const due = org.invoices.find((i) => ["awaiting_payment", "pending_confirmation"].includes(i.status));
  return (
    <div className="space-y-5" data-testid="org-billing">
      {due && <PayInvoice inv={due} onUpdated={onUpdated} />}
      <Card>
        <p className="font-heading font-semibold text-[#0B2545]">Payment & invoice history</p>
        {org.invoices.length === 0 ? <p className="text-sm text-slate-500 mt-2">No invoices yet.</p> : (
          <ul className="mt-3 divide-y divide-slate-100 text-sm">
            {org.invoices.map((i) => (
              <li key={i.id} className="py-2.5 flex flex-wrap justify-between gap-3" data-testid={`org-invoice-${i.number}`}>
                <span>{i.number} · {i.quote_ref} · {fmtDate(i.created_at)}</span>
                <span className="flex items-center gap-3">{money(i.amount, i.currency)} <Pill s={i.status} /></span>
              </li>
            ))}
          </ul>
        )}
      </Card>
    </div>
  );
}
